"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFunction = exports.ClientAppFunction = exports.CreateAppFunction = exports.PartialAppFunction = void 0;
var json2typescript_1 = require("json2typescript");
var PartialBaseAppFunction = (function () {
    function PartialBaseAppFunction(partial) {
        this.name = '';
        this.path = undefined;
        this.lastModified = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], PartialBaseAppFunction.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('path', String, true),
        __metadata("design:type", String)
    ], PartialBaseAppFunction.prototype, "path", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified', Number, true),
        __metadata("design:type", Number)
    ], PartialBaseAppFunction.prototype, "lastModified", void 0);
    PartialBaseAppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('PartialBaseAppFunction'),
        __metadata("design:paramtypes", [Object])
    ], PartialBaseAppFunction);
    return PartialBaseAppFunction;
}());
var PartialAppFunction = (function (_super) {
    __extends(PartialAppFunction, _super);
    function PartialAppFunction(partial) {
        var _this = _super.call(this, partial) || this;
        _this.id = '';
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialAppFunction.prototype, "id", void 0);
    PartialAppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('PartialAppFunction'),
        __metadata("design:paramtypes", [Object])
    ], PartialAppFunction);
    return PartialAppFunction;
}(PartialBaseAppFunction));
exports.PartialAppFunction = PartialAppFunction;
var BaseAppFunction = (function (_super) {
    __extends(BaseAppFunction, _super);
    function BaseAppFunction(partial) {
        var _this = _super.call(this, partial) || this;
        _this.source = '';
        _this.canEvaluate = undefined;
        _this.private = false;
        _this.runAsSystem = undefined;
        _this.runAsUserId = undefined;
        _this.runAsUserIdScriptSource = undefined;
        _this.runAsUserIdScriptTranspiledSource = undefined;
        _this.runAsUserIdScripSourceMap = undefined;
        _this.disableArgLogs = undefined;
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('source'),
        __metadata("design:type", Object)
    ], BaseAppFunction.prototype, "source", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('can_evaluate', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], BaseAppFunction.prototype, "canEvaluate", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('private'),
        __metadata("design:type", Object)
    ], BaseAppFunction.prototype, "private", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_system', Boolean, true),
        __metadata("design:type", Boolean)
    ], BaseAppFunction.prototype, "runAsSystem", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id', String, true),
        __metadata("design:type", String)
    ], BaseAppFunction.prototype, "runAsUserId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id_script_source', String, true),
        __metadata("design:type", String)
    ], BaseAppFunction.prototype, "runAsUserIdScriptSource", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id_script_transpiled_source', String, true),
        __metadata("design:type", String)
    ], BaseAppFunction.prototype, "runAsUserIdScriptTranspiledSource", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id_script_source_map', Buffer, true),
        __metadata("design:type", Buffer)
    ], BaseAppFunction.prototype, "runAsUserIdScripSourceMap", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disable_arg_logs', Boolean, true),
        __metadata("design:type", Boolean)
    ], BaseAppFunction.prototype, "disableArgLogs", void 0);
    BaseAppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('BaseAppFunction'),
        __metadata("design:paramtypes", [Object])
    ], BaseAppFunction);
    return BaseAppFunction;
}(PartialBaseAppFunction));
var CreateAppFunction = (function (_super) {
    __extends(CreateAppFunction, _super);
    function CreateAppFunction(partial) {
        var _this = _super.call(this, partial) || this;
        Object.assign(_this, partial);
        return _this;
    }
    CreateAppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('CreateAppFunction'),
        __metadata("design:paramtypes", [Object])
    ], CreateAppFunction);
    return CreateAppFunction;
}(BaseAppFunction));
exports.CreateAppFunction = CreateAppFunction;
var ClientAppFunction = (function (_super) {
    __extends(ClientAppFunction, _super);
    function ClientAppFunction(partial) {
        var _this = _super.call(this, partial) || this;
        _this.id = '';
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String),
        __metadata("design:type", Object)
    ], ClientAppFunction.prototype, "id", void 0);
    ClientAppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('ClientAppFunction'),
        __metadata("design:paramtypes", [Object])
    ], ClientAppFunction);
    return ClientAppFunction;
}(BaseAppFunction));
exports.ClientAppFunction = ClientAppFunction;
var AppFunction = (function (_super) {
    __extends(AppFunction, _super);
    function AppFunction(partial) {
        var _this = _super.call(this, partial) || this;
        _this.transpiledSource = undefined;
        _this.sourceMap = undefined;
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('transpiled_source', String, true),
        __metadata("design:type", String)
    ], AppFunction.prototype, "transpiledSource", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('source_map', Buffer, true),
        __metadata("design:type", Buffer)
    ], AppFunction.prototype, "sourceMap", void 0);
    AppFunction = __decorate([
        (0, json2typescript_1.JsonObject)('AppFunction'),
        __metadata("design:paramtypes", [Object])
    ], AppFunction);
    return AppFunction;
}(ClientAppFunction));
exports.AppFunction = AppFunction;
//# sourceMappingURL=Function.js.map